import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';


/* global customElements */
class ArchiveGrid extends BaseComponent {
	
	static get properties() {
		return {
			admin: {type: Boolean}
		};
	}
	
	constructor() {
		super();
				
		this.admin = false;		
				
		var archiveGrid = this;
		setTimeout(function(){
			archiveGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var archiveGrid = this;
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterCompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;' + (archiveGrid.admin ? '' : 'display: none;'),
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {
						Service.getCompanyService().getCompaniesLookup().then(function(data){
							combo.items = data;
						});
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							if (archiveGrid.admin) {								
								var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
								if (selectedCompany) {
									ElementUtil.query(toolbar, 'generate').disabled = false;
									ElementUtil.query(toolbar, 'upload').disabled = false;
								} else {
									ElementUtil.query(toolbar, 'generate').disabled = true;
									ElementUtil.query(toolbar, 'upload').disabled = true;
								}
							}
							actionRefresh();
						}
					}					
				}
			]
		});
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'generate',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_ARCHIVES:WRITE', 'ARCHIVES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:package', ' Create')						
					],
					listeners: {
						click: function() {
							actionGenerate();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'details',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_ARCHIVES:READ', 'ARCHIVES:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:file-text-o', ' Details')						
					],
					listeners: {
						click: function() {
							actionDetails(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'restore',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_ARCHIVES:WRITE', 'ARCHIVES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:share-square', ' Restore')						
					],
					listeners: {
						click: function() {
							actionRestore(grid.selectedItems[0]);
						}
					}					
				},				
				{
					tag: 'dl-action-button',
					itemid: 'download',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_ARCHIVES:READ', 'ARCHIVES:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:download', ' Download')						
					],
					listeners: {
						click: function() {
							actionDownload(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',					
							permissions: ['ADMIN_ARCHIVES:WRITE', 'ARCHIVES:WRITE'],							
							children:[
								ElementUtil.makeIcon('vaadin:upload', 'Upload')						
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}							
						},
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							theme: 'error primary',					
							permissions: ['ADMIN_ARCHIVES:DELETE', 'ARCHIVES:DELETE'],
							'class': 'spacer-toolbar-item',
							disabled: true,
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}		
			]
		});	
		
		if (archiveGrid.admin) {
			ElementUtil.query(toolbar, 'upload').disabled = true;
			ElementUtil.query(toolbar, 'generate').disabled = true;
		}
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{						
					path: 'companyName',
					header: 'Company Name',
					width: '7em'
				},	
				{						
					path: 'startDts',
					header: 'Data Start Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						if (rowData.item.startDts) {
							var date = TimeUtil.parseDate(rowData.item.startDts);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						} else {
							root.innerHTML = 'N/A';						
						}
					}
				},
				{						
					path: 'endDts',
					header: 'Data End Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						if (rowData.item.endDts) {
							var date = TimeUtil.parseDate(rowData.item.endDts);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						} else {
							root.innerHTML = 'N/A';
						}
					}
				},				
				{						
					path: 'archiveTypeDescription',
					header: 'Archive Type',
					width: '7em'
				},												
				{						
					path: 'runStatus',
					header: 'Status',
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.runStatus === 'FAILED' || rowData.item.runStatus === 'FAILED_RESTORE') {
							root.style.backgroundColor = '#ffbdbd';
						} else if (rowData.item.runStatus === 'COMPLETE_WITH_WARNINGS' || rowData.item.runStatus === 'COMPLETE_WARNINGS_RESTORE') {
							root.style.backgroundColor = 'lightyellow';
						} else if (rowData.item.status === 'PENDING' || rowData.item.status === 'PENDING_RESTORE') {
							root.style.backgroundColor = 'aliceblue';
						} else if (rowData.item.status === 'RUNNING' || rowData.item.status === 'RUNNING_RESTORE') {
							root.style.backgroundColor = 'lightgreen';
						} else {
							root.style.backgroundColor = '';
						}
						root.innerHTML = rowData.item.runStatusDescription;
					}
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},								
				{
					path: 'expiresInDays',
					header: 'Expires (Days)',
					'text-align': 'center',
					width: '5em',
					renderer: function(root, column, rowData)  {
						var days = rowData.item.expiresInDays;
						if (days < 0) {
							root.innerHTML = "Never";
						} else if (days === 0) {
							root.style.backgroundColor = '#ffbdbd';
							root.innerHTML = "< 1";
						} else if (days <= 3) {
							root.style.backgroundColor = 'ffbdbd';
							root.innerHTML = days;
						} else if (days > 3 && days < 7) {
							root.style.backgroundColor = 'yellow';
							root.innerHTML = days;
						} else {
							root.style.backgroundColor = '';
							root.innerHTML = days;
						}
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					
					if (grid.selectedItems.length > 0) {		
						
						ElementUtil.query(toolbar, 'delete').disabled = false; 
						
						//need to be in end state
						if (item.endState) {							
							ElementUtil.query(toolbar, 'restore').disabled = false; 
							ElementUtil.query(toolbar, 'details').disabled = false;
						} else {
							ElementUtil.query(toolbar, 'restore').disabled = true; 
							ElementUtil.query(toolbar, 'details').disabled = true;
						}
						
						if (item.downloadAvailable) {
							ElementUtil.query(toolbar, 'download').disabled = false; 
						} else {
							ElementUtil.query(toolbar, 'download').disabled = true; 
						}												
					} else {						
						ElementUtil.query(toolbar, 'details').disabled = true;
						ElementUtil.query(toolbar, 'restore').disabled = true; 
						ElementUtil.query(toolbar, 'delete').disabled = true; 
						ElementUtil.query(toolbar, 'download').disabled = true;						
					}
				}
			}
		});	
			
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			pageSize: 50,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
										
						var selectedCompany = null;
						if (archiveGrid.admin) {
							selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
							
							if (!selectedCompany) {
								loadMask.remove();
								window.DL.MessageUtil.showToast('Validation', 'Select a company first.', {									
										theme: 'error'
								});
								return;
							}
						}
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',
							dateField: 'updateDts'
						};
						
						if (selectedCompany) {
							grid.currentFilter.companyId = selectedCompany;
						}
		

						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;						
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
						
						Service.getArchiveService().getArchives(grid.currentFilter).then(function(records){
							successHandler(records);
						});						
					};	
					
					loadData();
														
				};
			},
			listeners: {
				ready: function() {		
					if (!archiveGrid.admin) {
						pagingToolbar.loadCurrentPage();					
					}
				}
			}
			
		});

		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				var exportFilter = Object.assign({}, grid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				Service.getArchiveService().exportArchives(exportFilter);
			}
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		archiveGrid.append(flexLayout);				
	
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};
				
		var actionGenerate = function() {
						
			var generateWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Create Archive',
				icon: 'vaadin:package',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						generateWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [										
										{	
											tag: 'vaadin-date-picker',
											itemId: 'startDate',
											label: 'Start Date(mm/dd/yyyy)',
											name: 'startDts',											
											required: true,
											listeners: {
												change: function() {
													ElementUtil.query(formPanel, 'endDate').min = ElementUtil.query(formPanel, 'startDate').value;
												}
											}
										},
										{
											tag: 'vaadin-date-picker',
											itemId: 'endDate',
											label: 'End Date(mm/dd/yyyy)',
											name: 'endDts',
											required: true,
											listeners: {
												change: function() {
													ElementUtil.query(formPanel, 'startDate').max = ElementUtil.query(formPanel, 'endDate').value;
												}
											}
										},				
										{
											tag: 'vaadin-combo-box',
											itemid: 'archiveType',
											label: 'Archive Type',
											name: 'archiveType',
											value: 'USER',
											'item-value-path': 'code',
											'item-label-path': 'description',										
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('ArchiveType').then(function (data) {
													var types = [];
													data.forEach(function(item){
														if (item.userType) {
															types.push(item);
														}
													});													
													combo.items = types;
													combo.required = true;
												});
											}
										},
										{	
											tag: 'fieldset',
											children: [
												{
													tag: 'legend',
													innerHTML: 'Record Types'
												},
												{
													tag: 'vaadin-checkbox',									
													name: 'enities-TRACTORS',
													value: 'TRACTORS',
													label: 'Tractors'
												},
												{ tag: 'br' },
												{
													tag: 'vaadin-checkbox',									
													name: 'enities-DRIVERS',
													value: 'DRIVERS',
													label: 'Drivers'
												},
												{ tag: 'br' },
												{
													tag: 'vaadin-checkbox',									
													name: 'enities-TRAILERS',
													value: 'TRAILERS',
													label: 'Trailers'
												},
												{ tag: 'br' },
												{
													tag: 'vaadin-checkbox',									
													name: 'enities-REPORTS',
													value: 'REPORTS',
													label: 'Report'
												},
												{ tag: 'br' },
												{
													tag: 'vaadin-checkbox',									
													name: 'enities-IMPORT_HISTORY',
													value: 'IMPORT_HISTORY',
													label: 'Import History'
												},
												{ tag: 'br' },
												{
													tag: 'vaadin-checkbox',									
													name: 'enities-GPS',
													value: 'GPS',
													label: 'GPS'
												},
												{ tag: 'br' },
												{
													tag: 'vaadin-checkbox',									
													name: 'enities-FUEL',
													value: 'FUEL',
													label: 'Fuel'
												},
												{ tag: 'br' },
												{
													tag: 'vaadin-checkbox',									
													name: 'enities-TRIP',
													value: 'TRIP',
													label: 'Trip'
												},
												{ tag: 'br' },
												{
													tag: 'vaadin-checkbox',									
													name: 'enities-DISTANCE_SUMMARIES',
													value: 'DISTANCE_SUMMARIES',
													label: 'Distance Summaries'
												},
												{ tag: 'br' },
												{
													tag: 'vaadin-checkbox',									
													name: 'enities-IDLE',
													value: 'IDLE',
													label: 'Idle'
												}
											]
										},
										{
											tag: 'vaadin-text-field',										
											name: 'note',
											label: 'Note',											
											colspan: 2,
											maxLength: 255											
										},																	
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:package', ' Create')
													],
													listeners: {
														click: function() {															
																				
															formPanel.submitForm({
																preSubmit: function(data) {	
																	var submitData = {
																		startDts: data.startDts,
																		endDts: data.endDts,
																		archiveType: data.archiveType,
																		note: data.note,
																		entitesInArchive: []
																	};

																	for(var key in data) {
																		if (key.startsWith('enities') && data[key]) {
																			var entity = key.split('-')[1];
																			submitData.entitesInArchive.push(entity);
																		}
																	}																																		
																	return submitData;
																},
																actualCall: function(data) {			

																	var selectedCompany = null;
																	if (archiveGrid.admin) {
																		selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
																	}																
																	
																	return Service.getArchiveService().createArchive(data, selectedCompany);																																																			
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Submited Archive request. Watch Tasks.', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	generateWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															generateWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						generateWin.addToContentElement(formPanel);
					}
				}
			});
			
		};			
		
		var actionRestore = function(record) {
						
			var restoreWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Restore Archive',
				icon: 'vaadin:share-square',				
				width: 800,
				height: .75,
				listeners: {
					ready: function() {						
						restoreWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [		
								{	
									tag: 'fieldset',
									children: [
										{
											tag: 'legend',
											innerHTML: 'Restore Options'
										},
										{
											tag: 'vaadin-checkbox',									
											name: 'option-RE-CALC',											
											label: 'Re-calc Data Loaded'
										},
										{ tag: 'br' },
										{
											tag: 'vaadin-checkbox',									
											name: 'option-SWITCH_COMPANIES',									
											label: 'Switch Companies (Required if archive is for a different company)'
										}
									]
								},
								{	
									tag: 'fieldset',
									children: [
										{
											tag: 'legend',
											innerHTML: 'Record Types To Restore'
										},
										{
											tag: 'div',
											innerHTML: 'WARNING: Units will update/add to current units'
										},
										{
											tag: 'vaadin-checkbox',		
											itemId: 'enities-TRACTORS',
											disabled: true,
											name: 'enities-TRACTORS',
											value: 'TRACTORS',
											label: 'Tractors'
										},
										{ tag: 'br' },
										{
											tag: 'vaadin-checkbox',	
											itemId: 'enities-DRIVERS',
											disabled: true,
											name: 'enities-DRIVERS',
											value: 'DRIVERS',
											label: 'Drivers'
										},
										{ tag: 'br' },
										{
											tag: 'vaadin-checkbox',		
											itemId: 'enities-TRAILERS',
											disabled: true,
											name: 'enities-TRAILERS',
											value: 'TRAILERS',
											label: 'Trailers'
										},				
										{ tag: 'br' },
										{
											tag: 'vaadin-checkbox',		
											itemId: 'enities-GPS',
											disabled: true,
											name: 'enities-GPS',
											value: 'GPS',
											label: 'GPS'
										},
										{ tag: 'br' },
										{
											tag: 'vaadin-checkbox',		
											itemId: 'enities-FUEL',
											disabled: true,
											name: 'enities-FUEL',
											value: 'FUEL',
											label: 'Fuel'
										},
										{ tag: 'br' },
										{
											tag: 'vaadin-checkbox',		
											itemId: 'enities-TRIP',
											disabled: true,
											name: 'enities-TRIP',
											value: 'TRIP',
											label: 'Trip'
										},
										{ tag: 'br' },
										{
											tag: 'vaadin-checkbox',
											itemId: 'enities-DISTANCE_SUMMARIES',
											disabled: true,
											name: 'enities-DISTANCE_SUMMARIES',
											value: 'DISTANCE_SUMMARIES',
											label: 'Distance Summaries'
										},
										{ tag: 'br' },
										{
											tag: 'vaadin-checkbox',		
											itemId: 'enities-IDLE',
											disabled: true,
											name: 'enities-IDLE',
											value: 'IDLE',
											label: 'Idle'
										}
									]
								},																				
								{
									tag: 'hr',
									colspan: 2
								},
								{
									tag: 'div',
									style: 'text-align: center;',
									colspan: 2,
									defaults: {
										tag: 'vaadin-button'
									},
									children: [
										{
											theme: 'primary',
											children: [
												ElementUtil.makeIcon('vaadin:share-square', ' Restore')
											],
											listeners: {
												click: function() {															

													formPanel.submitForm({
														preSubmit: function(data) {	
															var submitData = {
																restoreOptions: {},
																entitesToRestore: []
															};

															for(var key in data) {
																if (key.startsWith('option') && data[key]) {
																	var optionKey = key.split('-')[1];
																	submitData.restoreOptions[optionKey] = true;
																}
															}

															for(var key in data) {
																if (key.startsWith('enities') && data[key]) {
																	var entity = key.split('-')[1];
																	submitData.entitesToRestore.push(entity);
																}
															}																																		
															return submitData;
														},
														actualCall: function(data) {			

															var selectedCompany = null;
															if (archiveGrid.admin) {
																selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
															}						
															
															return Service.getArchiveService().restoreArchive(record.archiveId, selectedCompany, data);																																																			
														},
														success: function(data, responseData) {
															window.DL.MessageUtil.showToast('Success', 'Submited Restore Archive request. Watch Tasks.', {
																theme: 'success',
																position: 'top-stretch'
															});
															actionRefresh();
															restoreWin.close();
														}
													});															

												}
											}
										},
										{
											theme: 'tertiary',
											innerHTML: 'Cancel',
											style: 'margin-left: 10px;',
											listeners: {
												click: function() {
													//cancel
													restoreWin.close();
												}
											}
										}
									]
								}
							]							
						});							
	
						restoreWin.addToContentElement(formPanel);
						
						if(record) {
							if (record.entitesInArchive) {
								record.entitesInArchive.forEach(function(entity){
									var entityChk = ElementUtil.query(formPanel, 'enities-' + entity);
									if (entityChk) {
										entityChk.disabled = false;
									}
								});
							}
						}
						
					}
				}
			});
			
		};
				
		var actionDetails = function(record) {			
			var detailWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Details',
				icon: 'vaadin:modal-list',
				width: .75,
				height: .75,
				listeners: {
					ready: function () {
						detailWin.show();

						var detailTable = ElementUtil.create({
							tag: 'dl-detail-table',
							itemid: 'detailtable',
							slot: 'primary'
						});

						var updateDetails = function (detail) {
							var data = [
								{
									key: 'Archive',
									value: '-',
									section: true
								},
								{
									key: 'Archive Id',
									value: detail.archiveId
								},
								{
									key: 'Company Id',
									value: detail.companyId
								},
								{
									key: 'Company Name',
									value: detail.companyName
								},							
								{
									key: 'Data Start Date',
									value: detail.startDts ? TimeUtil.formatDateStandard(detail.startDts) : "N/A"
								},
								{
									key: 'Data End Date',
									value: detail.endDts ? TimeUtil.formatDateStandard(detail.endDts) : "N/A"
								},							
								{
									key: 'Archive Type',
									value: detail.archiveTypeDescription
								},
								{
									key: 'Run Status',
									value: detail.runStatusDescription
								},
								{
									key: 'Archive File',
									value: detail.archiveFile ? detail.archiveFile : 'Not Available'
								},
								{
									key: 'Expires in Days',
									value: detail.expiresInDays === -1 ? 'Never' : detail.expiresInDays
								},
								{
									key: 'Note',
									value: detail.note ? detail.note : ''
								},
								{
									key: 'Import Note',
									value: detail.importNote ? detail.importNote : ''
								},							
								{
									key: 'Archive Run Start Date',
									value: detail.archiveStartDts ? TimeUtil.formatDateStandard(detail.archiveStartDts) : "N/A"
								},
								{
									key: 'Archive Complete Date',
									value: detail.archiveCompleteDts ? TimeUtil.formatDateStandard(detail.archiveCompleteDts) : "N/A"
								},														
								{
									key: 'Restore Start Date',
									value: detail.restoreStartDate ? TimeUtil.formatDateStandard(detail.restoreStartDate) : "Not Restored"
								},
								{
									key: 'Restore Complete Date',
									value: detail.lastRestored ? TimeUtil.formatDateStandard(detail.lastRestored) : "Not Restored"
								},
								{
									key: 'Create User',
									value: detail.createUser
								},
								{
									key: 'Create Date',
									value: TimeUtil.formatDateStandard(detail.createDts)
								},
								{
									key: 'Update User',
									value: detail.updateUser
								},
								{
									key: 'Last Update Date',
									value: TimeUtil.formatDateStandard(detail.updateDts)
								}
							];

							if (detail.entitesInArchive) {
								data.push({
									key: 'Entities In Archive',
									value: '-',
									section: true
								});

								detail.entitesInArchive.forEach(function(item) {
									data.push({
										key: 'Entity',
										value: item
									});
								});
							}

							if (detail.restoreOptions) {
								data.push({
									key: 'Restore Options',
									value: '-',
									section: true
								});

								for (var key in detail.restoreOptions) {
									data.push({
										key: key,
										value: detail.restoreOptions[key]
									});
								}
							}

							//manifest	
							if (detail.manifest && detail.manifest.companyId) {
								data.push({
									key: 'Manifest',
									value: '-',
									section: true
								});

								data.push({
									key: 'Version',
									value: detail.manifest.version
								});
								data.push({
									key: 'App Version',
									value: detail.manifest.appVersion
								});

								data.push({
									key: 'Archive Date',
									value: detail.manifest.archiveDts ? TimeUtil.formatDateStandard(detail.manifest.archiveDts) : "N/A"
								});


								data.push({
									key: 'Data Start Date',
									value: detail.manifest.startDts ? TimeUtil.formatDateStandard(detail.manifest.startDts) : "N/A"
								});

								data.push({
									key: 'Data End Date',
									value: detail.manifest.endDts ? TimeUtil.formatDateStandard(detail.manifest.endDts) : "N/A"
								});
								data.push({
									key: 'Errors',
									value: detail.manifest.errors
								});
								data.push({
									key: 'Warnings',
									value: detail.manifest.warnings
								});

								if (detail.manifest.entries) {
									data.push({
										key: 'Manifest Entries',
										value: '-',
										section: true
									});

									detail.manifest.entries.forEach(function(item) {
											data.push({
												key: item.entityType + ' - ' + item.entity,
												value: item.numberOfRecords
											});
									});

								}							
							}

							detailTable.updateDetails(data);

							//update message grid
							messageGrid.items = detail.messages;
						};

						var detailedLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								detailTable
							]
						});

						var messageGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},
							children: [
								{
									path: 'messageTypeDescription',
									header: 'Type',
									width: '7em'
								},
								{
									path: 'message',
									header: 'Message',
									width: '12em'
								}
							]
						});

						var messageFooter = ExportUtil.createExportFooter({
							grid: messageGrid,
							itemid: 'archive-messages',
							showDetail: false
						});

						var messageLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								messageGrid,
								messageFooter.footerContainer
							]
						});

						var tabPanel = ElementUtil.create({
							tag: 'dl-tabpanel',
							listeners: {
								ready: function (e) {
									tabPanel.addTabs([
										{
											'tab-title': 'Manifest',
											tag: 'div',
											style: 'height: 100%;',
											children: [
												detailedLayout
											]
										},
										{
											'tab-title': 'Errors / Messages',
											tag: 'div',
											style: 'height: 100%;',
											children: [
												messageLayout
											]
										}
									]);
								}
							}
						});

						detailWin.addToContentElement(tabPanel);

						var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;	

						//pull Details
						var loadMask = tabPanel.showLoading();
						Service.getArchiveService().getArchiveManifest(record.archiveId, selectedCompany).then(function(manifest){
							Service.getArchiveService().getArchiveMessage(record.archiveId, selectedCompany).then(function(messages){
								loadMask.remove();
								
								var fullDetails = structuredClone(record);
								fullDetails.manifest = manifest;
								fullDetails.messages = messages;

								updateDetails(fullDetails);
							}, function() {
								loadMask.remove();
							});						
						}, function() {
							loadMask.remove();
						});

					}
				}
			});
		};			
		
		var actionUpload = function() {
			var uploadWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Upload Archive',
				icon: 'vaadin:upload',
				width: .60,
				height: 600,
				listeners: {
					ready: function() {						
						uploadWin.show();
						
						var uploadHandler = function() {
							
							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');
							
							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('An archive file is required.');
							} else if (archiveGrid.admin) {						
								var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
								if (!selectedCompany) {
									window.DL.MessageUtil.showOkMessage('Company Selection is required.');
								} else {
									uploadField.uploadFiles();
								}
							} else {
								uploadField.uploadFiles();
							}
							
						};
						
						var uploadFormPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								slot: 'primary',
								children: [									
									{
										tag: 'vaadin-upload',												
										itemid: 'uploadField',
										'no-auto':  true,
										'max-files': 1,
										required: true,												
										target: '/api/resource/archives/upload',
										headers: ImportUtil.getUploadHeader(),
										listeners: {
											'upload-request': function(event) {
												//var data = uploadFormPanel.getData();	

												if (archiveGrid.admin) {
													var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
													event.detail.formData.append('companyId', selectedCompany);
												}

											},
											'upload-response': function(event) {
											},
											'upload-success': function(event) {
												var responseData = JSON.parse(event.detail.xhr.responseText);
												if (responseData.errors) {
													uploadFormPanel.markFields(responseData.errors);															
												} else {
													actionRefresh();
													uploadWin.close();
												}
											}
										}
									},											
									{
										tag: 'vaadin-form-layout',										
										children: [											
											{
												tag: 'hr',
												colspan: 2
											},
											{
												tag: 'div',
												style: 'text-align: center;',
												colspan: 2,
												defaults: {
													tag: 'vaadin-button'
												},
												children: [
													{
														theme: 'primary',
														children: [
															ElementUtil.makeIcon('vaadin:upload', ' Upload')
														],
														listeners: {
															click: function() {
																if (uploadFormPanel.isValid()) {																	
																	uploadHandler();
																}
															}
														}
													},
													{
														theme: 'tertiary',
														innerHTML: 'Cancel',
														style: 'margin-left: 10px;',
														listeners: {
															click: function() {																
																uploadWin.close();
															}
														}
													}
												]
											}
										]
									}
								]
						});
						
						
						var uploadLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								uploadFormPanel
							]
						});		
						
						
						var ftpFormPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'ftpForm',
								slot: 'primary',
								children: [
									{
										tag: 'vaadin-form-layout',										
										children: [	
											{
												tag: 'vaadin-text-field',
												name: 'serverAddress',											
												label: 'Server Address',
												required: true,
												colspan: 2,
												maxLength: 255												
											},
											{
												tag: 'vaadin-text-field',
												name: 'userName',											
												label: 'User Name',
												required: true,
												colspan: 2,
												maxLength: 255												
											},
											{
												tag: 'vaadin-password-field',
												name: 'password',											
												label: 'Password',
												required: true,
												colspan: 2,
												maxLength: 255												
											},
											{
												tag: 'vaadin-text-field',
												name: 'filename',											
												label: 'Filename and Path',
												required: true,
												colspan: 2,
												maxLength: 255												
											},
											{
												tag: 'vaadin-number-field',
												name: 'port',											
												label: 'Port',												
												colspan: 2,
												min: 1,
												max: 65535
											},
											{
												tag: 'vaadin-checkbox',
												name: 'sftp',
												label: 'SFTP'
											},
											{
												tag: 'vaadin-checkbox',
												name: 'passive',
												checked: true,
												label: 'Passive'
											}
										]
									},
									{
										tag: 'vaadin-form-layout',										
										children: [											
											{
												tag: 'hr',
												colspan: 2
											},
											{
												tag: 'div',
												style: 'text-align: center;',
												colspan: 2,
												defaults: {
													tag: 'vaadin-button'
												},
												children: [
													{
														theme: 'primary',
														children: [
															ElementUtil.makeIcon('vaadin:upload', ' Upload')
														],
														listeners: {
															click: function() {
																
																ftpFormPanel.submitForm({
																	preSubmit: function(data) {																																									
																		return data;
																	},
																	actualCall: function(data) {			

																		var selectedCompany = null;
																		if (archiveGrid.admin) {
																			selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
																		}																

																		return Service.getArchiveService().ftpImportArchive(data, selectedCompany);																																																			
																	},
																	success: function(data, responseData) {
																		window.DL.MessageUtil.showToast('Success', 'Submited Request to Pull from FTP. Watch Notifications.', {
																			theme: 'success',
																			position: 'top-stretch'
																		});
																		actionRefresh();
																		uploadWin.close();
																	}
																});	
																
															}
														}
													},
													{
														theme: 'tertiary',
														innerHTML: 'Cancel',
														style: 'margin-left: 10px;',
														listeners: {
															click: function() {																
																uploadWin.close();
															}
														}
													}
												]
											}
										]
									}									
								]
						});						
						
						var ftpLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								ftpFormPanel
							]
						});							
						
						var tabPanel = ElementUtil.create({
							tag: 'dl-tabpanel',
							listeners: {
								ready: function (e) {
									tabPanel.addTabs([
										{
											'tab-title': 'Upload Archive',
											tag: 'div',
											style: 'height: 100%;',
											children: [
												uploadLayout
											]
										},
										{
											'tab-title': 'FTP Archive',
											tag: 'div',
											style: 'height: 100%;',
											children: [
												ftpLayout
											]
										}
									]);
								}
							}
						});						
						
						uploadWin.addToContentElement(tabPanel);
						
					}
				}
				
				
			});				
		};			
			
		var actionDownload = function(record) {			
			Service.getArchiveService().downloadArchive(record.archiveId);			
		};			
			
		var actionDelete = function(record) {
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete the selected archive?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing Archive...');

							Service.getArchiveService().deleteArchive(record.archiveId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed Archive', {									
									theme: 'success'
								});
								actionRefresh();
							})
							.catch(function(){
								loadMask.remove();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
					
		};	
				
	}
	
}
customElements.define('dl-archive-grid', ArchiveGrid);